/**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Skeleton text types.
 */
export enum SKELETON_TEXT_TYPE {
  /**
   * Regular variant.
   */
  REGULAR = '',

  /**
   * Heading variant.
   */
  HEADING = 'heading',

  /**
   * Line variant.
   */
  LINE = 'line',
}
